import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ODataConfiguration } from './angularODataConfiguration';
import { ODataService } from './angularODataService';

@Injectable({ providedIn: 'root' })
export class ODataServiceFactory {
  private readonly config = inject(ODataConfiguration);
  private readonly http = inject(HttpClient);

  public CreateService<T>(typeName: string, config?: ODataConfiguration): ODataService<T> {
    return new ODataService<T>(typeName, this.http, config ? config : this.config);
  }
}
